// TOP LEVEL IMPORTS
import React from 'react';
import Gravatar from 'react-gravatar';

const ClientHeaderLeft = ({ client }) => {
  if (client.image) {
    return <img alt="user-avatar" src={client.image} style={{ width: 100, height: 100, borderRadius: '50%' }} />;
  }
  return (
    <Gravatar
      default="mm" // https://en.gravatar.com/site/implement/images/
      src={client.image}
      size={100}
      email={(client.email && client.email) || ''}
    />
  );
};

export default ClientHeaderLeft;



// WEBPACK FOOTER //
// ./src/routes/app-client-detail/ClientHeader/ClientHeaderLeft/index.js